import { AppError, EipError } from 'src/redux/types';
export const formatErrorMessage = checkoutError => {
  switch (checkoutError) {
    case AppError.MINT_LOW_USER_RAKING_LEVEL:
      return 'Reach Private rank to mint item';

    case AppError.MINT_LIMIT_TIME:
      return 'Mint is cooling down, please try it later';

    case AppError.OUTDATED_BUYING:
      return 'Outdated buying';

    case AppError.NOT_ENOUGH_THC:
      return 'Not enough Thetan coin';

    case AppError.NOT_ENOUGH_THG:
      return 'Not enough Thetan gem';

    case AppError.ID_INVALID:
      return 'ID not valid';

    case AppError.ABORTED_BY_USER:
      return 'Aborted by user';

    case AppError.NOT_OWNER_HERO:
      return 'You are the owner of this cosmetic';

    case AppError.HERO_NOT_AVAILABLE:
    case AppError.HERO_HAS_BEEN_RENTED:
      return 'Cosmetic is not available';

    case AppError.HERO_ID_INVALID:
      return `Cosmetic's ID is not valid`;

    case AppError.UNNKOWN:
    case EipError.UNNKOWN:
      return 'Something went wrong. Please try again!.';

    case AppError.INVALID_OWNER:
      return 'This item has been sold!';

    case EipError.USER_REJECTED_REQUEST:
      return 'Transaction has been canceled';

    case EipError.INVALID_ADDRESS:
      return 'The currently used wallet differs from the linked account wallet';

    default:
      return `Error code ${checkoutError}`;
  }
};